import { SET_APP_CONFIG } from './app-config-actions';

export default function appConfig(state = {}, action) {
  switch (action.type) {
    case SET_APP_CONFIG:
      return action.payload;
    default:
      return state;
  }
}
